import React from 'react';
import { graphql } from 'gatsby';
import classnames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import Container from '../Container';
import Pancake from './Pancake';
import PancakeIntro from '../PancakeIntro';

import Card from '../Card';

import 'swiper/css';
import './CustomerQuotes.scss';

const CustomerQuotes = (props) => {
  const { className, quotes, theme, title, text } = props;

  return (
    <Pancake className={classnames('CustomerQuotes', className)} theme={theme}>
      <Container>
        {(title || text) && <PancakeIntro title={title} text={text} />}
        {quotes?.length > 0 && (
          <div className="CustomerQuotesSwiperContainer">
            <button
              className="CustomerQuotesSwiperArrows swiper-button-prev"
              aria-label="Previous slide"
            >
              <ArrowIcon />
            </button>
            <Swiper
              spaceBetween={25}
              modules={[Navigation]}
              className="CustomerQuotesSwiper"
              breakpoints={{
                640: {
                  slidesPerView: 2,
                },
                1000: {
                  slidesPerView: 3,
                },
              }}
              navigation={{
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
              }}
            >
              {quotes.map((quote) => {
                return (
                  <SwiperSlide className="FeaturesHighlightSwiperSlide">
                    <Card shadowLevel={'Low'}>
                      <div className="CustomerQuotesQuote">{quote.quote}</div>
                      <footer className="CustomerQuotesFooter">
                        <img
                          src={quote.author.image.asset.url}
                          alt={quote.author.name}
                          loading="lazy"
                          className="CustomerQuotesAuthorThumbnail"
                        />
                        <div>
                          <div className="CustomerQuotesAuthorName">
                            {quote.author.name}
                          </div>
                          <div className="CustomerQuotesAuthorJobTitle">
                            {quote.author.jobtitle}
                            {quote.showAuthorsCompany &&
                            quote.author.company?.name
                              ? `, ${quote.author.company.name}`
                              : ''}
                          </div>
                        </div>
                      </footer>
                    </Card>
                  </SwiperSlide>
                );
              })}
            </Swiper>
            <button
              className="CustomerQuotesSwiperArrows swiper-button-next"
              aria-label="Next slide"
            >
              <ArrowIcon />
            </button>
          </div>
        )}
      </Container>
    </Pancake>
  );
};

const ArrowIcon = () => (
  <svg
    width="13"
    height="20"
    viewBox="0 0 13 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.68209 10.157L0.762558 3.23744L3.23744 0.762573L12.6318 10.157L3.23743 19.5513L0.762565 17.0765L7.68209 10.157Z"
      fill="currentColor"
    />
  </svg>
);

export const query = graphql`
  fragment SanityPancakeCustomerQuotes on SanityCustomerQuotes {
    _key
    pancakeIntro {
      pancakeText
      pancakeTitle
    }
    theme
    quotes: quote {
      author {
        name
        jobtitle
        company {
          name
        }
        image {
          asset {
            url
          }
        }
      }
      quote
      showAuthorsCompany
    }
    _type
  }
`;

export default CustomerQuotes;
